/**
 * Process Admin table entity – Area | Process | Subprocess (FlexibleCRUDTable).
 * Rows are from listProcessSubprocessTable(); id is subprocess_id ?? process_id for row identity.
 */
import type { EntityDefinition } from '@/types/crud';

export const processAdminEntity: EntityDefinition = {
  name: 'processAdmin',
  displayName: 'Process Admin',
  displayNameSingular: 'Process / Subprocess',
  apiEndpoint: '/admin/process-admin',
  idField: 'id',
  nameField: 'process_name',
  copyable: false,
  deletable: true,
  searchable: true,
  sortable: true,
  pageSize: 25,
  fields: [
    { key: 'area_name', label: 'Area', type: 'text', order: 1 },
    { key: 'process_name', label: 'Process', type: 'text', order: 2 },
    { key: 'subprocess_name', label: 'Subprocess', type: 'text', order: 3 }
  ],
  tableColumns: [
    { key: 'area_name', label: 'Area', sortable: true, width: '20%' },
    { key: 'process_name', label: 'Process', sortable: true, width: '30%' },
    { key: 'subprocess_name', label: 'Subprocess', sortable: true, width: '35%' }
  ],
  searchFields: ['area_name', 'process_name', 'subprocess_name'],
  defaultSort: { field: 'area_name', direction: 'asc' }
};
